import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-h-primary-50 border py-2"
}
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = {
  key: 1,
  class: "container mx-auto flex w-12/12 sm:w-10/12 lg:w-8/12 justify-center my-10"
}
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex justify-between items-center mb-10" }
const _hoisted_6 = { class: "text-xl md:text-2xl font-bold" }
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = {
  id: "question-type-card",
  class: "shadow p-5 rounded bg-white flex flex-col gap-8 items-center justify-center mb-10"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-bold self-start" }, /*#__PURE__*/_toDisplayString("Formato*"), -1)
const _hoisted_10 = {
  id: "type",
  class: "bg-h-primary-50 border-2 border-h-primary-400 text-h-primary-400 rounded p-5 text-center text-xl flex items-center justify-center gap-2"
}
const _hoisted_11 = { class: "bg-gray-50 p-5 text-center w-full text-lg text-gray-600" }
const _hoisted_12 = { class: "flex flex-col gap-10" }
const _hoisted_13 = {
  id: "prompt",
  class: "flex flex-col gap-3"
}
const _hoisted_14 = { class: "p-5 bg-white rounded-md shadow-sm border" }
const _hoisted_15 = { id: "prompt" }
const _hoisted_16 = { class: "mb-2 text-lg font-bold" }
const _hoisted_17 = {
  key: 0,
  id: "material-reference",
  class: "p-5 bg-white rounded-md shadow-sm border"
}
const _hoisted_18 = { class: "my-4" }
const _hoisted_19 = { class: "mb-5 font-bold text-lg" }
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = { class: "flex items-center gap-5" }
const _hoisted_22 = { class: "w-fit line-clamp-1" }
const _hoisted_23 = { class: "w-12/12 md:w-2/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_BreadcrumbComponent = _resolveComponent("BreadcrumbComponent")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_QuestionComponent = _resolveComponent("QuestionComponent")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_Loader, {
      loader: _ctx.formLoader,
      label: "Carregando...",
      loaderType: "progress",
      loaderSize: "h-96"
    }, null, 8, ["loader"]),
    (!_ctx.formLoader)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_BreadcrumbComponent, {
              home: _ctx.home,
              items: _ctx.items
            }, null, 8, ["home", "items"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.formLoader)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitQuestion && _ctx.submitQuestion(...args)), ["prevent"])),
              class: "w-auto"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$route.params.id
                  ? _ctx.$t("quiz.teacher.edit")
                  : _ctx.$t("quiz.teacher.add")), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Button, {
                    id: "btn-cancel",
                    label: _ctx.$t('labels.cancel'),
                    class: "btn-outline p-button-sm",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmModal()))
                  }, null, 8, ["label"]),
                  _createVNode(_component_Button, {
                    id: "btn-submit-questions",
                    label: _ctx.$t('labels.save'),
                    class: "btn-primary p-button-sm",
                    type: "submit"
                  }, null, 8, ["label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_v_icon, {
                    name: _ctx.getQuestionType()?.icon,
                    scale: "2"
                  }, null, 8, ["name"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.getQuestionType()?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getQuestionType()?.info), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("question.prompt.title")) + "* ", 1),
                      _createVNode(_component_Textarea, {
                        id: "description-input",
                        autoResize: true,
                        rows: "5",
                        cols: "30",
                        placeholder: _ctx.$t('question.prompt.empty'),
                        modelValue: _ctx.form.prompt,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.prompt) = $event)),
                        class: _normalizeClass(_ctx.v$.form.prompt.$error ? 'p-invalid' : ''),
                        maxlength: 999
                      }, null, 8, ["placeholder", "modelValue", "class"]),
                      _createVNode(_component_Errors, {
                        errors: _ctx.v$.form.prompt.$errors,
                        actualLength: _ctx.form?.prompt?.length,
                        maxLength: 999
                      }, null, 8, ["errors", "actualLength"])
                    ])
                  ])
                ]),
                (_ctx.questionStore.isAdaptive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("question.reference")) + "* ", 1),
                        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("question.selectMaterials")), 1),
                        _createVNode(_component_AutoComplete, {
                          id: "contents-input",
                          optionLabel: "name",
                          modelValue: _ctx.form.contents,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.contents) = $event)),
                          suggestions: _ctx.autocomplete.suggestions,
                          multiple: true,
                          forceSelection: true,
                          delay: 500,
                          onComplete: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchForContents($event))),
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createContents($event))),
                          onItemSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateContents($event))),
                          onItemUnselect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearContents($event))),
                          class: _normalizeClass(`${
                    _ctx.v$.form.contents.$error ? 'p-invalid' : ''
                  } w-full`)
                        }, null, 8, ["modelValue", "suggestions", "class"]),
                        _createVNode(_component_Errors, {
                          errors: _ctx.v$.form.contents.$errors
                        }, null, 8, ["errors"])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.materialReferences, (item, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "my-4",
                          key: i
                        }, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("span", _hoisted_22, _toDisplayString(item.name ?? _ctx.form.contents?.filter((e) => e)[i]?.name), 1),
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_InputMask, {
                                id: "duration-input",
                                mask: "99:99:99",
                                modelValue: item.referenceTime,
                                "onUpdate:modelValue": ($event: any) => ((item.referenceTime) = $event),
                                placeholder: "00:00:00",
                                class: _normalizeClass(
                        _ctx.v$.form.materialReferences?.$each.$response.$errors &&
                        _ctx.v$.form.materialReferences?.$each.$response.$errors[i]
                          .referenceTime?.length !== 0 &&
                        _ctx.v$.form.$error
                          ? 'p-invalid'
                          : ''
                      )
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                              (_ctx.v$.form.materialReferences.$each.$response.$errors)
                                ? (_openBlock(), _createBlock(_component_Errors, {
                                    key: 0,
                                    errors: 
                        _ctx.v$.form.materialReferences.$each.$response.$errors[i]
                          .referenceTime
                      
                                  }, {
                                    msg: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("validations.required")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["errors"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_QuestionComponent)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog)
  ]))
}